import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './AuthorizationTickets.scss';
import {
  Button,
  Radio,
} from 'shared/components';
import OnlineTestingService from '../OnlineTestingService';

const AuthorizationTickets = ({ listOfExaminees, testCenterEventId }) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('list');
  const showTickets = isOpen ? 'display-tickets' : '';
  const toggleTickets = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionChange = (e) => {
    setSelected(e.target.value);
  };

  const onClickDownload = async (status) => {
    const regIds = [];
    if (listOfExaminees.some(e => e.id )) {
      listOfExaminees.forEach((examinee) => regIds.push(examinee.id));
    } else if (listOfExaminees.some(e => e.regId )) {
      listOfExaminees.forEach((examinee) => regIds.push(examinee.regId));
    }

    const data = {
      layout: status,
      regIds,
      testCenterEventId: testCenterEventId
    };

    const response = await OnlineTestingService.getAuthTickets(data);
    if (response.url) {
      const link = document.createElement('a');
      link.href = response.url;
      link.id = 'pdf';
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="tickets">
      <div className={`tickets-content-container ${showTickets}`}>
        <div className="tickets-content">
          <div className="radio">
            <Radio
              value="list"
              label="list"
              checked={selected === 'list'}
              onChange={handleOptionChange}
            />
          </div>
          <div className="radio">
            <Radio
              value="page"
              label="1 per page"
              checked={selected === 'page'}
              onChange={handleOptionChange}
            />
          </div>
          <div className="separator"></div>
          <Button
            type={'btn-primary btn-small'}
            text={t('onlineTesting.authorizationTickets.download')}
            onClick={() => {onClickDownload(selected); setIsOpen(!isOpen);}}
          />
          {/*{*/}
          {/*  downloadSelection &&*/}
          {/*  <div className="d-flex justify-content-center">*/}
          {/*    <button className="btn-link" onClick={() => {onClickDownload(selected, true); setIsOpen(!isOpen);}}>Download selection</button>*/}
          {/*  </div>*/}
          {/*}*/}
        </div>

      </div>
      <div className={`title ${isOpen && 'open-title'}`} onClick={toggleTickets}>
        <h6>{t('onlineTesting.authorizationTickets.title')}</h6>
        <div className={`icon-container ${isOpen && 'icon-open'}`}></div>
      </div>
    </div>
  );
};

export default AuthorizationTickets;

AuthorizationTickets.propTypes = {
  listOfExaminees: PropTypes.arrayOf(PropTypes.shape({})),
};
